import { useAtom } from '@reatom/npm-react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'

import { userPremiumTabAtom, type UserPremiumTab } from '@root/features/premium'
import { Screen } from '@root/shared/layout'
import { useTranslation } from '@root/shared/localization'
import { UnderlineTabs } from '@root/shared/ui-kit'

import { UserPremiumList } from './user-premium-list'

export const UserPremiumScreen = () => {
  const { t } = useTranslation()
  const [tab, setTab] = useAtom(userPremiumTabAtom)

  return (
    <Root>
      <Tabs value={tab} onChange={setTab}>
        <UnderlineTabs.Tab value={'active' satisfies UserPremiumTab}>
          <Trans i18nKey="premium.purchased.tab.active" />
        </UnderlineTabs.Tab>
        <UnderlineTabs.Tab value={'past' satisfies UserPremiumTab}>
          {t('premium.purchased.tab.inactive')}
        </UnderlineTabs.Tab>
      </Tabs>
      <UserPremiumList />
    </Root>
  )
}

const Root = styled(Screen)`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
`

const Tabs = styled(UnderlineTabs<UserPremiumTab>)`
  justify-content: center;
  border-bottom: 2px solid var(--background-1);

  button {
    margin-bottom: -2px;

    > span {
      margin-top: 3px;
    }
  }

  margin-bottom: 12px;
`
